
import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-red-800 text-white">
      {/* Footer Top */}
      <div className="border-b border-red-700 py-8">
        <div className="container mx-auto px-4">
          <div className="flex flex-col md:flex-row items-center justify-between">
            <div className="mb-4 md:mb-0">
              <img
                src="https://static.readdy.ai/image/69983b9b992309f9f345f22b715baa7c/e71b203b8eb359858883703c12223489.png"
                alt="ASSA OSGB - Adana İş Sağlığı ve Güvenliği"
                className="h-24"
              />
            </div>
            <div className="flex space-x-4">
              <a
                href="https://www.instagram.com/assaosgb"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white hover:text-red-300 cursor-pointer"
                aria-label="ASSA OSGB Instagram"
              >
                <i className="ri-instagram-fill text-2xl"></i>
              </a>
              <a
                href="https://www.youtube.com/channel/UCeUi5Ttxt9K3qKJMr753s-A"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white hover:text-red-300 cursor-pointer"
                aria-label="ASSA OSGB YouTube"
              >
                <i className="ri-youtube-fill text-2xl"></i>
              </a>
              <a
                href="https://www.facebook.com/assaosgb"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white hover:text-red-300 cursor-pointer"
                aria-label="ASSA OSGB Facebook"
              >
                <i className="ri-facebook-fill text-2xl"></i>
              </a>
              <a
                href="https://twitter.com/assaosgb"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white hover:text-red-300 cursor-pointer"
                aria-label="ASSA OSGB Twitter"
              >
                <i className="ri-twitter-fill text-2xl"></i>
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Footer Center */}
      <div className="py-12">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8">
            {/* OSGB Section */}
            <nav aria-label="OSGB Hizmetleri">
              <h4 className="text-lg font-bold text-white mb-4">OSGB</h4>
              <ul className="space-y-2">
                <li>
                  <Link
                    to="/osgb/isyeri-hekimi"
                    className="text-red-100 hover:text-white transition-colors cursor-pointer"
                  >
                    İşyeri Hekimi
                  </Link>
                </li>
                <li>
                  <Link
                    to="/osgb/is-guvenligi-uzmani"
                    className="text-red-100 hover:text-white transition-colors cursor-pointer"
                  >
                    İş Güvenliği Uzmanı
                  </Link>
                </li>
                <li>
                  <Link
                    to="/osgb/diger-saglik-personeli"
                    className="text-red-100 hover:text-white transition-colors cursor-pointer"
                  >
                    Diğer Sağlık Personeli
                  </Link>
                </li>
                <li>
                  <Link
                    to="/osgb/risk-degerlendirmesi"
                    className="text-red-100 hover:text-white transition-colors cursor-pointer"
                  >
                    Risk Değerlendirmesi
                  </Link>
                </li>
              </ul>
            </nav>

            {/* Eğitimler Section */}
            <nav aria-label="İSG Eğitimleri">
              <h4 className="text-lg font-bold text-white mb-4">Eğitimler</h4>
              <ul className="space-y-2">
                <li>
                  <Link
                    to="/egitimler/isg-temel-egitimi"
                    className="text-red-100 hover:text-white transition-colors cursor-pointer"
                  >
                    İSG Temel Eğitimi
                  </Link>
                </li>
                <li>
                  <Link
                    to="/egitimler/yuksekte-calisma-egitimi"
                    className="text-red-100 hover:text-white transition-colors cursor-pointer"
                  >
                    Yüksekte Çalışma Eğitimi
                  </Link>
                </li>
                <li>
                  <Link
                    to="/egitimler/yangin-egitimi"
                    className="text-red-100 hover:text-white transition-colors cursor-pointer"
                  >
                    Yangın Eğitimi
                  </Link>
                </li>
                <li>
                  <Link
                    to="/egitimler/acil-durum-egitimleri"
                    className="text-red-100 hover:text-white transition-colors cursor-pointer"
                  >
                    Acil Durum Eğitimleri
                  </Link>
                </li>
                <li>
                  <Link
                    to="/egitimler/ilkyardim-egitimi"
                    className="text-red-100 hover:text-white transition-colors cursor-pointer"
                  >
                    İlkyardım Eğitimi
                  </Link>
                </li>
                <li>
                  <Link
                    to="/egitimler/meslek-egitimi"
                    className="text-red-100 hover:text-white transition-colors cursor-pointer"
                  >
                    Meslek Eğitimi ve MYK
                  </Link>
                </li>
              </ul>
            </nav>

            {/* Danışmanlık */}
            <nav aria-label="Danışmanlık Hizmetleri">
              <h3 className="text-white font-bold text-lg mb-4">Danışmanlık</h3>
              <ul className="space-y-2">
                <li>
                  <Link
                    to="/danismanlik/cevre-danismanligi"
                    className="text-red-100 hover:text-white transition-colors cursor-pointer"
                  >
                    Çevre Danışmanlığı
                  </Link>
                </li>
                <li>
                  <Link
                    to="/danismanlik/ortam-olcumleri"
                    className="text-red-100 hover:text-white transition-colors cursor-pointer"
                  >
                    Ortam Ölçümleri
                  </Link>
                </li>
                <li>
                  <Link
                    to="/danismanlik/periyodik-kontroller"
                    className="text-red-100 hover:text-white transition-colors cursor-pointer"
                  >
                    Periyodik Kontroller
                  </Link>
                </li>
                <li>
                  <Link
                    to="/danismanlik/tehlikeli-madde"
                    className="text-red-100 hover:text-white transition-colors cursor-pointer"
                  >
                    Tehlikeli Madde Danışmanlığı
                  </Link>
                </li>
                <li>
                  <Link
                    to="/danismanlik/hirdavat-kkd"
                    className="text-red-100 hover:text-white transition-colors cursor-pointer"
                  >
                    Hırdavat ve KKD
                  </Link>
                </li>
                <li>
                  <Link
                    to="/danismanlik/pkd-atex"
                    className="text-red-100 hover:text-white transition-colors cursor-pointer"
                  >
                    PKD ve ATEX Çözümleri
                  </Link>
                </li>
              </ul>
            </nav>

            {/* Laboratuvar Section */}
            <nav aria-label="Laboratuvar Hizmetleri">
              <h4 className="text-lg font-bold text-white mb-4">Laboratuvar</h4>
              <ul className="space-y-2">
                <li>
                  <Link
                    to="/laboratuvar/hizmet-laboratuvari"
                    className="text-red-100 hover:text-white transition-colors cursor-pointer"
                  >
                    Basit Hizmet Laboratuvarı
                  </Link>
                </li>
                <li>
                  <Link
                    to="/laboratuvar/ise-giris-saglik-raporu"
                    className="text-red-100 hover:text-white transition-colors cursor-pointer"
                  >
                    İşe Giriş Sağlık Raporu
                  </Link>
                </li>
                <li>
                  <Link
                    to="/laboratuvar/mobil-saglik-araci"
                    className="text-red-100 hover:text-white transition-colors cursor-pointer"
                  >
                    Mobil Sağlık Aracı
                  </Link>
                </li>
              </ul>
            </nav>

            {/* İletişim Section */}
            <div>
              <h4 className="text-lg font-bold text-white mb-4">İletişim</h4>
              <address className="not-italic">
                <ul className="space-y-3">
                  <li className="flex items-start">
                    <i className="ri-map-pin-line text-white mt-1 mr-2"></i>
                    <span className="text-red-100">
                      Reşatbey Mahallesi, 62015 Sokak No:4
                      <br />
                      ASSA Plaza Seyhan / Adana
                    </span>
                  </li>
                  <li className="flex items-center">
                    <i className="ri-phone-line text-white mr-2"></i>
                    <a
                      href="tel:08503462772"
                      className="text-red-100 hover:text-white transition-colors cursor-pointer"
                    >
                      0850 346 2772
                    </a>
                  </li>
                  <li className="flex items-center">
                    <i className="ri-mail-line text-white mr-2"></i>
                    <a
                      href="mailto:assa@assaisg.com"
                      className="text-red-100 hover:text-white transition-colors cursor-pointer"
                    >
                      assa@assaisg.com
                    </a>
                  </li>
                </ul>
              </address>
            </div>
          </div>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="border-t border-red-700 py-6">
        <div className="container mx-auto px-4">
          <div className="flex flex-col md:flex-row items-center justify-between">
            <p className="text-red-100 text-sm mb-2 md:mb-0">
              Copyright © 2025{' '}
              <a
                href="https://www.assa.tr"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-white cursor-pointer"
              >
                ASSA
              </a>{' '}
              - Tüm Hakları Saklıdır
            </p>
            <a
              href="https://readdy.ai/?ref=logo"
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="text-red-200 hover:text-white text-sm cursor-pointer"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
